import { useHttpClient } from '../../http/index';
import { GetAchievementsResponse } from './types';

const { get } = useHttpClient();

export const useAchievementsApi = () => {
  const getAchievements = async () => {
    const { data } = await get<GetAchievementsResponse>('/v1/trader/achievements_showcases');

    return data.attributes;
  };

  return {
    getAchievements,
  };
};
